import styled from 'styled-components';
import { space, SpaceProps } from 'styled-system';
import { StyledDiv } from '../../../Theme/CommonStyled';

export const StyledListItem = styled.div<SpaceProps>`
  width: 100%;
  height: 90px;
  border: none;
  position: relative;
  padding: 14px;
  direction: rtl;
  cursor: pointer;
  align-items: center;
  justify-content: space-between;
  font-size: ${({ theme }): string => theme.fontSizes[4]};
  font-weight: ${({ theme }): string => theme.fontWeights[6]};
  border-radius: ${({ theme }): string => theme.radii.xl};
  background-color: ${({ theme }): string => theme.colors.secondaryBackground};
  color: ${({ theme }): string => theme.colors.normalText};
  ${space}
`;

export const StyledAddress = styled(StyledDiv)`
  text-align: right;
  color: ${({ theme }): string => theme.colors.secondaryText};
  font-size: ${({ theme }): string => theme.fontSizes[2]};
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: 22px;
  overflow: hidden;
`;
